// Light, non-auth UI state (just the unit preference, used as a default for
// inputs before the user's profile loads). Identity now comes from Supabase Auth
// via the useSession hook in src/auth.ts — no more localStorage user_id.

const KEY_UNIT_PREF = 'reslt.unit_preference';

export type UnitPref = 'metric' | 'imperial';

export function getStoredUnitPref(): UnitPref {
  const v = localStorage.getItem(KEY_UNIT_PREF);
  return v === 'imperial' ? 'imperial' : 'metric';
}

export function setStoredUnitPref(pref: UnitPref): void {
  localStorage.setItem(KEY_UNIT_PREF, pref);
}
